var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCultery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24986 21.75V12.6577C6.43833 12.482 5.75468 12.0714 5.19891 11.4259C4.64313 10.7804 4.36523 10.0102 4.36523 9.11538V2.25H5.86521V9.11538H7.24986V2.25H8.74981V9.11538H10.1345V2.25H11.6344V9.11538C11.6344 10.0102 11.3565 10.7804 10.8008 11.4259C10.245 12.0714 9.56134 12.482 8.74981 12.6577V21.75H7.24986ZM16.8652 21.75V13.75H14.1345V6.99998C14.1345 5.75128 14.5354 4.66827 15.3373 3.75095C16.1392 2.83365 17.1485 2.33974 18.3652 2.26922V21.75H16.8652Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultery);
export default __webpack_public_path__ + "static/media/Cultery.106a82bc73966d5c78815c76a10184b6.svg";
export { ForwardRef as ReactComponent };